import { useTranslation } from "react-i18next";
import { Badge } from "../../../components/ui/badge";
import { cn } from "../../../lib/utils";
import type { IncidentStatus } from "../api";
import { STATUS_BADGE_CLASS, STATUS_DOT_CLASS, STATUS_LABEL_KEY } from "../status";

/** Colored status pill. Colour is functional and never the sole signal. */
export function StatusBadge({
  status,
}: {
  status: IncidentStatus;
}): JSX.Element {
  const { t } = useTranslation();
  const labelKey = STATUS_LABEL_KEY[status];
  return (
    <Badge
      variant="outline"
      className={cn("gap-1.5 border", STATUS_BADGE_CLASS[status])}
    >
      {/* K6: per-status dot inside the pill; the label stays the primary cue. */}
      <span
        aria-hidden="true"
        className={cn(
          "inline-block h-1.5 w-1.5 rounded-full",
          STATUS_DOT_CLASS[status],
        )}
      />
      {t(labelKey)}
    </Badge>
  );
}
